<template>
  <div flex="1">
    <div class="attractions-detail">
      <BaseAZError v-if="isError" />
      <template v-else>
        <van-swipe
          lazy-render
          class="detail-swipe h-[14.5rem]"
          :autoplay="3000"
          indicator-color="white"
        >
          <van-swipe-item v-for="image in attrBasicInfo?.attrImgList" :key="image">
            <van-image :src="image" height="100%" width="100%" fit="cover" />
          </van-swipe-item>
        </van-swipe>
        <div class="relative rounded-t-xl bg-white -mt-8">
          <div pt="3" pb="1">
            <div class="line-clamp-2 px-4" font="600" leading="7" text="5.5 black">
              {{ attrBasicInfo?.attrName }}
            </div>
            <div class="flex items-center px-4 pt-4">
              <div class="mr-4 flex items-center">
                <NuxtIcon name="attr-icon:star" text="base" style="color: var(--tc-color-primary);" />
                <span class="text-sm font-500" style="color: var(--tc-color-primary);">{{ attrBasicInfo?.rating }}</span>
              </div>
              <div class="mr-4 flex flex-1 items-center overflow-hidden">
                <NuxtIcon name="my-icon:location" text="sm #808080" />
                <van-popover placement="bottom-start" class="detail-popover">
                  <template #reference>
                    <span class="ml-1 w-full text-xs text-[#838383] font-300">
                      {{ attrBasicInfo?.address }}
                    </span>
                  </template>
                  <div class="p-2 text-xs text-[#838383] font-300">
                    {{ attrBasicInfo?.address }}
                  </div>
                </van-popover>
              </div>
              <div class="flex items-center" :style="{ color: 'var(--tc-color-primary)' }" @click="getAttrDetail">
                <span class="text-xs font-300">{{ t('key.attraction.detail.detail') }}</span>
                <NuxtIcon name="material-symbols:chevron-right" text="4"></NuxtIcon>
              </div>
            </div>
            <van-divider />
            <div class="flex px-4">
              <MobileSelectDate class="mr-2" flex="shrink-0" :is-detail="true" :attr-name="attrBasicInfo?.attrName ?? ''">
                <template #default="{ formatDate }">
                  <div
                    h="9"
                    flex="~ 1 items-center shrink-0"
                    b="~ 1 solid #00000014"
                    rounded="3.5"
                    bg="#F3F3F3"
                    p="x-4"
                  >
                    <img :width="21" src="~assets/icons/icon-calendar.png" />
                    <div class="ml-2 text-sm text-[#121212]">
                      {{ formatDate }}
                    </div>
                  </div>
                </template>
              </MobileSelectDate>
              <BusinessBSelectTicket :page-type="E_RANK_TYPE.ATTRACTIONS" :is-detail="true" :attr-name="attrBasicInfo?.attrName ?? ''">
                <template #default="{ checkedLabel }">
                  <div
                    class="absolute right-0 z-1 h-3 w-3 rounded-full bg-black text-center text-8px text-white leading-3 -top-1"
                  >
                    {{ filterConditionsStore.filterConditions.detailFilterIdList?.length || 0 }}
                  </div>
                  <div
                    h="9"
                    flex="~ 1 items-center"
                    b="~ 1 solid #00000014"
                    rounded="3.5"
                    bg="#F3F3F3"
                    p="x-4"
                  >
                    <img :width="16" src="~assets/icons/icon-huge.png" />
                    <div class="line-clamp-1 ml-2 text-sm text-[#121212]">
                      {{ checkedLabel }}
                    </div>
                  </div>
                </template>
              </BusinessBSelectTicket>
            </div>
          </div>
        </div>

        <BusinessBTicketOptions class="mb-2.5 pl-2.5 pr-2.5" :style="{ paddingLeft: '10px', paddingRight: '10px' }"></BusinessBTicketOptions>
        <GroupedProduct />
        <BaseAZPopup
          v-model:show="showPopup"
          :title="t('key.attraction.detail.title')"
        >
          <div class="detail-content pb-4" v-html="attrDetail?.data?.attrDesc"></div>
        </BaseAZPopup>

        <van-popup
          v-model:show="priceCalendarState.isShow"
          position="bottom"
          h="full"
          close-icon-position="top-left"
          closeable
          safe-area-inset-bottom
          close-on-popstate
        >
          <MobilePriceCalendar v-if="priceCalendarState.isShow" :attr-id="attrId" />
        </van-popup>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import GroupedProduct from './_components/GroupedProduct.vue'
import { E_RANK_TYPE } from '~/enums'

const {
  attrDetail,
  attrBasicInfo,
  showPopup,
  isError,
  attrId,
  getAttrDetail,
} = useAttractionDetail()

const { state: priceCalendarState } = usePriceCalendarState()
const filterConditionsStore = useFilterConditionsStore()

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.attractions-detail {
  width: 100%;
  :deep(.el-carousel__button) {
    border-radius: 100%;
    width: 8px;
    height: 8px;
    margin: 0 1px;
  }
}

.detail-content {
  :deep(img) {
    max-width: 100%;
  }
}
</style>
